import { module } from 'modujs';
import { ScrollTrigger } from '../gsap'

export default class Inview extends module {

    static get settings() {
        return {
            VISIBLE_CLASS: 'is-inview'
        }
    }

    constructor(m) {
        super(m);

        // Start parameters : data-module-inview-start
        this.start = this.getData('start') || 'top 90%'

        // End parameters : data-module-inview-end
        this.end = this.getData('end') || 'bottom 10%'

        // Toggle once parameters : data-module-inview-once
        this.once = this.getData('once') || true

        // Callback on enter : data-module-inview-enter
        this.onEnter = this.getData('enter') || function(){}
    }

    init() {
        requestAnimationFrame(() => this.setScrollTrigger())

        window.addEventListener('resizeEnd', this.onResize = () => this.resize())
    }

    setScrollTrigger() {

        this.st = ScrollTrigger.create({
            trigger: this.el,
            start: this.start,
            end: this.end,
            toggleClass: Inview.settings.VISIBLE_CLASS,
            toggleActions: 'play none reverse none',
            once: this.once,
            onEnter: this.onEnter,
        });
    }

    resize() {
        this.st.kill()
        this.setScrollTrigger()
    }

    destroy() {
        this.st.kill()
    }
}
